var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgFavorite = function SvgFavorite(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 15.33",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.653 6.947a1.148 1.148 0 0 0-.636-1.957l-3.874-.563a.5.5 0 0 1-.382-.274L9.029.64a1.147 1.147 0 0 0-2.058 0L5.239 4.153a.5.5 0 0 1-.382.277l-3.873.56a1.148 1.148 0 0 0-.637 1.958l2.8 2.732a.5.5 0 0 1 .146.449l-.661 3.858a1.12 1.12 0 0 0 .25.93 1.16 1.16 0 0 0 1.414.279l3.465-1.822a.52.52 0 0 1 .472 0l3.468 1.822a1.14 1.14 0 0 0 .534.134 1.15 1.15 0 0 0 .88-.413 1.12 1.12 0 0 0 .25-.93l-.664-3.858a.5.5 0 0 1 .146-.449Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFavorite);
export default ForwardRef;